import { Component, OnDestroy, OnInit } from '@angular/core';
import { CALENDAR_LOCALE } from '../../services/constant';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { ApiService } from '../../services/api.service';
import { Router } from '@angular/router';
import {finalize} from "rxjs/operators";
import {SellerDetail} from "../seller/seller.model";
import {HttpParams} from "@angular/common/http";

@Component({
  selector: 'app-abb-dashboard',
  templateUrl: './abb-dashboard.component.html',
  styleUrls: ['./abb-dashboard.component.scss']
})
export class AbbDashboardComponent implements OnInit, OnDestroy {
  abbNo: string;
  outlet: string;
  currentPage = 1;
  itemsPerPage = 40;
  startDate: Date = null;
  endDate: Date = null;
  minDate: Date;
  maxDate: Date;
  calendarLocale = CALENDAR_LOCALE.TH;
  loading = false;
  totalItems = 0;
  tableData = [];

  // sellerDetails: SellerDetail[] = [];
  // sellerNames: string[] = [];
  // searchSeller: string;
  // searchingSeller: boolean = false;

  branchCode: string[] = [];
  searchBranch: string;
  searchingBranch: boolean = false;
  branchList: Array<{outlet: string}> = [];

  searchOutlet: string;
  searchingOutlet: boolean = false;
  outletList: Array<{outlet: string}> = [];


  subs: Subscription;

  constructor(
    private apiService: ApiService,
    private router: Router,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.subs = this.translateService.onLangChange.subscribe(() => {
      this.clear()
      this.loadInput();
      this.search();
    });
    this.loadInput();
    this.search();
  }

  loadInput() {
    this.calendarLocale = this.translateService.currentLang === 'en'
      ? CALENDAR_LOCALE.EN
      : CALENDAR_LOCALE.TH;

    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 60);
    this.endDate = new Date();

    // this.loadSeller();
    this.loadBranch();
    this.loadOutlet();
  }

  get yearRange() {
    const thisYear = (new Date()).getFullYear();
    return (thisYear - 40) + ':' + thisYear;
  }

  get dateRange() {
    if (!this.startDate && !this.endDate) {
      return null;
    }

    const start = this.startDate ? moment(this.startDate).format('DD/MM/YYYY') : '';
    const end = this.endDate ? moment(this.endDate).format('DD/MM/YYYY') : '';
    return start + ' - ' + end;
  }

  setMinDate() {
    this.minDate = this.startDate;
  }

  setMaxDate() {
    this.maxDate = this.endDate;
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  search(resetPageNumber = true) {
    if (resetPageNumber) {
      this.currentPage = 1;
    }

    let params = new HttpParams()
      .set('abb_no', this.abbNo || '')
      .set('issue_dt_after', moment(this.startDate).format('YYYY-MM-DD'))
      .set('issue_dt_before', moment(this.endDate).format('YYYY-MM-DD'))
      .set('page', this.currentPage.toString())
      .set('page_size', this.itemsPerPage.toString());

    // if (this.searchSeller) {
    //   params = params.set('company', this.searchSeller);
    // }

    if (this.searchBranch) {
      params = params.set('branch_code', this.searchBranch);
    }

    if (this.searchOutlet) {
      params = params.set('outlet', this.searchOutlet);
    }

    this.loading = true;
    this.apiService.getAbbData(params).subscribe(
      (response) => {
        this.loading = false;
        this.tableData = response.results;
        this.totalItems = response.count;
      },
      (error) => {
        this.loading = false;
        console.error(error);
      },
    );
  }

  clear() {
    // this.searchSeller = null;
    this.searchBranch = null;
    this.searchOutlet = null;
    this.abbNo = null;
    this.outlet = null;
    this.loadInput();
    this.search();
  }

  pageChanged() {
    this.search(false);
  }

  optionChanged() {
    this.search();
  }

  gotoDocumentIssue(data) {
    this.router.navigate(['document', 'issue'], {queryParams: {abbData: data.id}});
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  // loadSeller() {
  //   this.loading = true;
  //
  //   this.apiService.getSellerBranch()
  //     .pipe(
  //       finalize(() => {
  //         this.loading = false;
  //       })
  //     )
  //     .subscribe(
  //       (res: SellerDetail[]) => {
  //         this.sellerDetails = res;
  //
  //         this.setSellerNames();
  //       }
  //     );
  // }

  loadBranch() {
    this.loading = true;

    this.apiService.getBranch()
      .pipe(finalize(() => { this.loading = false; }))
      .subscribe(
        (res: any) => {
            this.branchList = res.map(branch => ({
              branch_code: branch.code,
              full_name: branch.full_name
            }));
            this.setBranch(this.branchList);
        },
        (error) => {
          console.error('Error fetching branch data', error);
        }
      );
  }

  loadOutlet(): void {
    this.loading = true;

    this.apiService.getABBOutletDropdown()
      .pipe(
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe(
        (res: any) => {
            for (let i = 0; i < res.length; i++) {
                this.outletList.push(res[i].outlet);
            }
            this.setOutlet(this.outletList);
        },
        (error) => {
          console.error('Error fetching outlet data', error);
        }
      );
  }

  // setSellerNames() {
  //   if (this.translateService.currentLang === 'en') {
  //     this.sellerNames = this.sellerDetails.map(seller => seller.name_en);
  //   } else {
  //     this.sellerNames = this.sellerDetails.map(seller => seller.name_th);
  //   }
  //   this.sellerNames = this.sellerNames
  //     .filter((value, index, array) => array.indexOf(value) === index);
  // }

  setBranch(branchData: any[]) {
    this.branchCode = branchData.filter(
      (value, index, array) =>
        array.findIndex(branch => branch.branch_code === value.branch_code) === index
    );
  }

  setOutlet(outletData: any): void {
    this.outlet = outletData.filter((value, index, array) =>
      array.indexOf(value) === index);
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/abb-dashboard/abb-dashboard.component.ts